// https://vuescrolljs.yvescoding.org/guide/configuration.html
export default {
  props: {
    listItems: Array,
    scrollClass: String,
  },

  data() {
    return {
      ops: {
        rail: {
          background: "rgba(255, 255, 255, .15)",
          opacity: 1,
          size: "10px",
          specifyBorderRadius: "0px",
        },
        bar: {
          background: "#DCDCDC",
          opacity: 1,
          size: "4px",
          specifyBorderRadius: "0px",
          keepShow: true,
        },
      },
    };
  },

  computed: {
    getScrollOverlayClass() {
      return ["scroll-overlay", this.scrollClass];
    },
  },
};
